import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  overflow: hidden;
`;

export const ConversationLayout = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

export const ConversationSidebar = styled.div<{ $collapsed?: boolean }>`
  width: ${({ $collapsed }) => ($collapsed ? '60px' : '400px')};
  height: 100%;
  display: flex;
  background-color: ${({ theme }) => theme.token.colorBgContainer};
  border-left: 1px solid ${({ theme }) => theme.token.colorBorder};
  transition: width 0.3s ease;
`;

export const SidebarMenu = styled.div<{ $collapsed?: boolean }>`
  width: 60px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 16px;
  border-right: 1px solid ${({ theme }) => theme.token.colorBorder};
  background-color: ${({ theme }) => theme.token.colorBgElevated};
`;

export const SidebarMenuItem = styled.div<{
  $active?: boolean;
  $collapsed?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  cursor: pointer;
  color: ${({ theme, $active }) =>
    $active ? theme.token.colorPrimary : theme.token.colorText};
  position: relative;
`;

export const SidebarContent = styled.div<{ $collapsed?: boolean }>`
  flex: 1;
  display: ${({ $collapsed }) => ($collapsed ? 'none' : 'flex')};
  flex-direction: column;
  overflow: hidden;
`;

export const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
`;

export const SidebarHeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  white-space: nowrap;
`;

export const SidebarView = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
`;

export const MessagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  overflow-y: scroll;
  padding: 1rem 0.5rem;
  height: 100%;
  scroll-behavior: smooth;

  // Add mask for top fade
  mask-image: linear-gradient(
    to bottom,
    transparent,
    black 10px,
    black calc(100% - 10px),
    transparent
  );

  // For browsers that need the webkit prefix
  -webkit-mask-image: linear-gradient(
    to bottom,
    transparent,
    black 10px,
    black calc(100% - 10px),
    transparent
  );
`;

export const MessageWrapper = styled.div<{
  $role: 'user' | 'assistant' | 'system';
}>`
  display: flex;
  justify-content: ${({ $role }) =>
    $role === 'user' ? 'flex-end' : 'flex-start'};
  max-width: 95%;
  align-self: ${({ $role }) => ($role === 'user' ? 'flex-end' : 'flex-start')};
  margin-bottom: 0.5rem;

  .ant-card {
    width: 100%;
    background: ${({ $role, theme }) =>
      $role === 'user' ? '' : theme.token.colorBgElevated};
    border: 1px solid ${({ theme }) => theme.token.colorBorder};
    border-radius: ${({ theme }) => theme.token.borderRadiusLG}px;
    box-shadow: ${({ theme }) => theme.token.boxShadowTertiary};
  }
`;

export const InputContainer = styled.div`
  padding: 8px;
  flex-shrink: 0;
  background: ${({ theme }) => theme.token.colorBgContainer};
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: center;
  width: 100%;

  > * {
    max-width: 800px;
    width: 100%;
  }
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 1rem;

  img {
    width: 300px;
    height: auto;
    opacity: 0.8;
  }
`;

export const TaskItem = styled.div`
  padding: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.token.colorBorder};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.token.colorBgTextHover};
  }
`;

export const TaskTitle = styled.div`
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TaskStatus = styled.div`
  margin-bottom: 4px;
`;

export const TaskTime = styled.div`
  color: ${({ theme }) => theme.token.colorTextSecondary};
`;

export const SuggestionContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0.75rem;
  margin-bottom: 0.5rem;

  .ant-btn {
    border-radius: 16px;
    padding: 4px 16px;
    height: auto;
    font-size: 13px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: all 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }
  }
`;
